import { VerifyAuthResponse } from '@common/api/authService';

const TRIAL_DAYS = 7;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

interface BuildOnboardingTrialProfileOptions {
    profile: VerifyAuthResponse | null;
    planId: string;
    planCode: string;
    planName: string;
    billingCycle: string;
    now?: Date;
}

export const buildOnboardingTrialProfile = ({
    profile,
    planId,
    planCode,
    planName,
    billingCycle,
    now = new Date(),
}: BuildOnboardingTrialProfileOptions): VerifyAuthResponse | null => {
    if (!profile) return profile;

    const startAt = now.toISOString();
    const trialEndAt = new Date(now.getTime() + TRIAL_DAYS * MS_PER_DAY).toISOString();

    return {
        ...profile,
        workspacePlan: {
            ...profile.workspacePlan,
            planId,
            planCode,
            planName,
            status: 'trial',
            billingCycle,
            provider: 'free',
            tier: profile.workspacePlan?.tier || planCode,
            currency: profile.workspacePlan?.currency || 'USD',
            startAt,
            currentPeriodStart: startAt,
            currentPeriodEnd: trialEndAt,
            trialEndAt,
            cancelAtPeriodEnd: false,
        },
    };
};
